const Filters = ({
  assignees,
  clients,
  contacts,
  queues,
  regionStatusNames,
  serviceCategories,
  tags,
  clientStatuses
}) => {
  const assigneeOptions = _(assignees).map(({ id, name }) => ({ value: id, label: name })).uniqBy('label').sortBy('label').value()
  assigneeOptions.splice(0, 0, { value: 'Not yet assigned', label: 'Unassigned' })

  return (
    [
      {
        value: 'Client',
        type: 'is',
        subject: 'client_id',
        values: _(clients).map(({ id, short_name }) => ({ value: id, label: short_name }))
          .uniqBy('label')
          .sortBy('label')
          .value(),
        employeeOnly: false
      },
      {
        value: 'Contact',
        type: 'is',
        values: _(contacts).map(({ id, name }) => ({ value: id, label: name })).uniqBy('label').sortBy('label')
          .value(),
        employeeOnly: false
      },
      {
        value: 'Category',
        type: 'is',
        values: serviceCategories,
        employeeOnly: false
      },
      {
        value: 'Assignee',
        type: 'is',
        subject: 'assignee_user_id',
        values: assigneeOptions,
        employeeOnly: true
      },
      {
        value: 'Created',
        subject: 'created_at',
        type: 'between',
        employeeOnly: false
      },
      {
        value: 'Queue',
        subject: 'queue_id',
        type: 'is',
        values: _(queues).map(({ id, name }) => ({ value: id, label: name })).uniqBy('label').sortBy('label').value(),
        employeeOnly: true
      },
      {
        value: 'Description',
        type: 'contains',
        subject: 'description',
        employeeOnly: false
      },
      {
        value: 'Child ticket',
        type: 'is',
        subject: 'child',
        values: [{ value: 'false', label: 'No' }, { value: 'true', label: 'Yes' }],
        employeeOnly: true
      },
      {
        value: 'Priority',
        subject: 'priority_id',
        type: 'is',
        values: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }],
        employeeOnly: false
      },
      {
        value: 'Status',
        subject: 'status_id',
        type: 'is',
        values: regionStatusNames,
        employeeOnly: false
      },
      {
        value: 'Key Client',
        subject: 'key_client',
        type: 'is',
        values: [{ value: 'false', label: 'No' }, { value: 'true', label: 'Yes' }],
        employeeOnly: true
      },
      {
        value: 'Tag',
        subject: 'tag_ids',
        type: 'is',
        values: tags.map(({ id: value, name: label }) => ({ value, label })),
        employeeOnly: true
      },
      {
        value: 'Client Status',
        subject: 'client_status',
        type: 'is',
        values: clientStatuses,
        employeeOnly: true
      },
      {
        value: 'Security Issue',
        subject: 'security_issue',
        type: 'is',
        // Do not change the values. To work correctly, false must be a string
        // and true must be a boolean value.
        values:  [{ value: "false", label: 'No' }, { value: true, label: 'Yes' }],
        employeeOnly: true
      }
    ]
  )
}

export default Filters
